export const BASE_URL = '/forecast-submission-panel-ui';
export const EMPTY_VALUE = '—';